
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/state/legislative-wrap-up",
      function () {
        return require("private-next-pages/advocacy/state/legislative-wrap-up/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/state/legislative-wrap-up"])
      });
    }
  